const getters = {
  app: state => state.app,
  user: state => state.user,
  ports: state => state.ports,
  dictionaries: state => state.dictionary.dictionaries,
  settings: state => state.settings.settings,

  // sidebarOpened: state => {
  //   console.log('state: %o', state)
  //   return state.app.sidebar.opened
  // }
  sidebar: state => state.app.sidebar,
  language: state => state.app.getLanguage,
  // languages: state => state.app.getLanguages
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  name: state => state.user.name,
  tableColumns: state => state.columns,
  //
  mvzspp: state => state.mvzspp
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js